import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import type { Table } from '@tanstack/react-table';
import { exportToCSV } from '../utils/csv';

interface ExportButtonProps<T> {
  table: Table<T>;
  filename: string;
}

export default function ExportButton<T>({ table, filename }: ExportButtonProps<T>) {
  const handleExport = () => {
    const rows = table.getFilteredRowModel().rows;
    const visibleColumns = table.getVisibleLeafColumns();

    const columns = visibleColumns.map((col) => ({
      header:
        typeof col.columnDef.header === 'string' ? col.columnDef.header : col.id,
      accessorKey: col.id,
    }));

    const data = rows.map((row) => {
      const obj: Record<string, unknown> = {};
      visibleColumns.forEach((col) => {
        obj[col.id] = row.getValue(col.id);
      });
      return obj;
    });

    exportToCSV(data, columns, filename);
  };

  return (
    <button
      onClick={handleExport}
      className="flex items-center gap-1.5 px-3 py-2 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
    >
      <ArrowDownTrayIcon className="w-4 h-4" />
      Export CSV
    </button>
  );
}
